/**
 * Generated by orval v8.12.3 🍺
 * Do not edit manually.
 * 十八线_接口文档
 * 十八线——小众旅游
 * OpenAPI spec version: 版本号:0.0.1
 */
import type {
  AjaxResult,
  MerchantAuditDTO,
  MerchantDetailPathParameters,
  MerchantListParams,
  MerchantRemovePathParameters,
  TableDataInfo,
  TravelMerchant
} from '../../../types/api';

import { orvalMutator } from '../../../utils/orval-mutator';



  export const get = () => {
/**
 * @summary 修改商户（审核字段不可由此接口修改）
 */
const merchantEdit = (
    travelMerchant: TravelMerchant,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/merchant`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: travelMerchant
    },
      );
    }
  /**
 * @summary 新增商户（待审核，不能直接建成可收款主体）
 */
const merchantAdd = (
    travelMerchant: TravelMerchant,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/merchant`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: travelMerchant
    },
      );
    }
  /**
 * @summary 入驻审核（通过前校验开票能力/执照/对公账户）
 */
const merchantAudit = (
    merchantAuditDTO: MerchantAuditDTO,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/merchant/audit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: merchantAuditDTO
    },
      );
    }
  /**
 * @summary 查询商户详情
 */
const merchantDetail = (
    { merchantId }: MerchantDetailPathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/merchant/${merchantId}`, method: 'GET'
    },
      );
    }
  /**
 * @summary 查询商户列表
 */
const merchantList = (
    params: MerchantListParams,
 ) => {
      return orvalMutator<TableDataInfo>(
      {url: `/travel18/merchant/list`, method: 'GET',
        params
    },
      );
    }
  /**
 * @summary 删除商户（软删除，有未结算流水时拒绝）
 */
const merchantRemove = (
    { merchantIds }: MerchantRemovePathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/merchant/${merchantIds}`, method: 'DELETE'
    },
      );
    }
  return {merchantEdit,merchantAdd,merchantAudit,merchantDetail,merchantList,merchantRemove}};
export type MerchantEditResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['merchantEdit']>>>
export type MerchantAddResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['merchantAdd']>>>
export type MerchantAuditResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['merchantAudit']>>>
export type MerchantDetailResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['merchantDetail']>>>
export type MerchantListResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['merchantList']>>>
export type MerchantRemoveResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['merchantRemove']>>>
